import { Stack } from "@mui/material";
import tcaLogo from "assets/images/tca/tca_logo.png";
import ymcaLogo from "assets/images/tca/ymca_logo.png";

const YmcaPageHeader = () => {
  return (
    <Stack direction={"row"} className="headerLogo" marginBottom={2}>
      <img src={ymcaLogo} height="85" />
      <img src={tcaLogo} height="85" />
    </Stack>
  );
};

export default YmcaPageHeader;
